import React from 'react';
import { motion } from 'framer-motion';
import { PriceDisplay } from './PriceDisplay';
import { Check, ShieldCheck } from 'lucide-react';
export function ProductPresentation() {
  const cartLink = 'https://superlibrodigital.com/cart/clear?return_to=/cart/add?id=56060036874566&quantity=1';
  return <section className="py-10 md:py-20 bg-parchment-50 overflow-hidden content-section" data-id="element-319">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-320">
        <div className="text-center mb-6 md:mb-10" data-id="element-321">
          <span className="text-gold-600 font-bold tracking-widest uppercase text-sm" data-id="element-322">
            Presentamos...
          </span>
          <h2 className="font-heading text-3xl md:text-6xl font-bold text-navy-900 mt-2 mb-4" data-id="element-323">
            Biblia Visual
          </h2>
          <p className="font-heading text-lg md:text-2xl text-gray-600 italic" data-id="element-324">
            "
            <span className="highlight-gold font-semibold text-navy-800 not-italic" data-id="element-325">
              La Guía Visual Definitiva
            </span>{' '}
            de las Sagradas Escrituras"
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-2xl border border-gray-100 overflow-hidden" data-id="element-326">
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-327">
            {/* Product Image Side */}
            <div className="bg-gray-100 p-4 md:p-10 flex items-center justify-center relative overflow-hidden min-h-[300px]" data-id="element-328">
              <div className="absolute inset-0 bg-[url('https://cdn.magicpatterns.com/uploads/8pXEWgJw2Ybb6zEandU8Pa/20260225_1321_Image_Generation_simple_compose_01kjasn752fkcaamye3aerbje9.png')] bg-cover bg-center" data-id="element-329"></div>
            </div>

            {/* Product Details Side */}
            <div className="p-5 md:p-12 flex flex-col justify-center" data-id="element-330">
              <div className="flex flex-wrap gap-2 mb-3 md:mb-6" data-id="element-331">
                <span className="bg-navy-100 text-navy-800 text-xs font-bold px-3 py-1 rounded-full" data-id="element-332">
                  280+ Imágenes HD
                </span>
                <span className="bg-navy-100 text-navy-800 text-xs font-bold px-3 py-1 rounded-full" data-id="element-333">
                  66 Libros Cubiertos
                </span>
                <span className="bg-navy-100 text-navy-800 text-xs font-bold px-3 py-1 rounded-full" data-id="element-334">
                  500+ Páginas
                </span>
              </div>

              <p className="text-gray-700 mb-4 md:mb-8 text-lg" data-id="element-335">
                Recorre visualmente los{' '}
                <span className="font-bold text-navy-900" data-id="element-336">
                  66 libros de la Biblia
                </span>{' '}
                con imágenes paso a paso...{' '}
                <span className="italic text-gray-600" data-id="element-337">
                  incluso si nunca has puesto un pie en Tierra Santa.
                </span>
              </p>

              <div className="mb-2 text-center md:text-left bg-gold-50/50 p-4 rounded-lg border border-gold-100" data-id="element-338">
                <p className="text-sm text-gray-500 uppercase font-bold tracking-wide" data-id="element-339">
                  PRECIO DE OFERTA:
                </p>
                <div className="flex flex-col items-center md:items-start mt-1" data-id="element-340">
                  <PriceDisplay type="compare" originalClassName="text-2xl text-gray-400 line-through decoration-red-500 font-normal" data-id="element-341" />
                  <PriceDisplay type="current" className="text-4xl md:text-5xl font-bold text-burgundy-600" data-id="element-342" />
                </div>
                <p className="text-sm text-gray-500 mt-2" data-id="element-343">
                  <span className="font-medium text-gray-700" data-id="element-344">Pago único</span>{' '}
                  ·{' '}
                  <span className="font-medium text-gray-700" data-id="element-345">
                    Sin suscripciones
                  </span>{' '}
                  ·{' '}
                  <span className="font-medium text-gray-700" data-id="element-346">
                    Sin cargos ocultos
                  </span>
                </p>
              </div>

              <div className="mt-4 md:mt-8" data-id="element-347">
                <a href={cartLink} className="block w-full text-center bg-gold-500 hover:bg-gold-600 text-white font-bold py-4 px-6 rounded-lg shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 text-lg uppercase tracking-wide will-change-transform" data-id="element-348">
                  QUIERO MI BIBLIA VISUAL
                </a>
                <p className="text-center text-xs text-gray-500 mt-3 flex items-center justify-center" data-id="element-349">
                  <Check className="w-3 h-3 mr-1 text-green-500" data-id="element-350" /> Descarga
                  inmediata de todo el paquete
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}